import { ARTBOARD_WRAPPER_DOM_ID } from 'Render/utils/importers';

export const unescapeHtml = (url) => {
  const div = document.createElement('div');
  const sanitizedUrl = url.replace(/{{(.*?)}}/g, '');
  div.innerHTML = sanitizedUrl;
  return div.innerText;
};

export const appendHtmlToElement = (html, element) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const elements = Array.prototype.slice.call(div.childNodes);
  [...elements].forEach(e => element.appendChild(e));
};

export const appendStyleToElement = (html, element) => {
  const styleNode = document.createElement('style');
  styleNode.type = 'text/css';
  element.appendChild(styleNode);
  styleNode.innerHTML = html;
};

export const getScrollbarWidth = (rootDocument) => {
  const div = rootDocument.createElement('div');
  div.innerHTML = `<div id="${ARTBOARD_WRAPPER_DOM_ID}" style="width: 100px; height: 100px; overflow: scroll; position: absolute; top: -9999px;"/>`;
  const scrollDiv = div.firstChild;
  rootDocument.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  rootDocument.body.removeChild(scrollDiv);
  return scrollbarWidth;
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/index.js